export default "/images/JacekGronostajski.jpg?5e2337b838a214b4be6a7c22f49a7a38";